import {SignUpComponent} from "../SignUpComponent.js";

export class IconButton extends SignUpComponent {

    template() {
        const {id = '', buttonText = '', desc  ='' } = this.$props;
        return `
                <button id="${id}" class="js-icon-button">
                    ${this.getIconTemplate()}
                    <div>
                        <em>${buttonText}</em>
                        ${desc !== '' ? `<span>${desc}</span>` : ''}
                    </div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                            <path d="M6.75 5L11.25 9.5L6.75 14" stroke="#999999" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </i>
                </button>
        `
    }
    getIconTemplate() {
        const { icon = '' } = this.$props;
        if (icon === 'plus') {
            return this.plusIconTemplate()
        }

        if (icon === 'clip') {
            return this.clipIconTemplate()
        }

        if (icon === 'person') {
            return this.externalEmplTemplate()
        }

        if (icon === 'company') {
            return this.internalEmplTemplate()
        }

        return ''
    }

    // 회사설정 - 1.회사만들기 아이콘
    plusIconTemplate() {
        return `
            <i>
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none">
                    <circle cx="17" cy="17.5" r="17" fill="#9F00BA"/>
                    <path d="M17.0002 11.1207L17.0002 23.8795" stroke="white" stroke-width="1.7" stroke-linecap="round"/>
                    <path d="M10.6217 17.4988L23.3759 17.4988" stroke="white" stroke-width="1.7" stroke-linecap="round"/>
                </svg>
            </i>
        `
    }
    // 회사설정 - 2.직원참여 아이콘
    clipIconTemplate() {
        return `
            <i>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="34" height="34" rx="17" fill="#1ECDC3"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8285 19.3039C10.8912 20.2411 10.8912 21.7607 11.8285 22.698C12.7657 23.6352 14.2853 23.6352 15.2226 22.698L17.4853 20.4352C17.7977 20.1228 18.3043 20.1228 18.6167 20.4352C18.9291 20.7477 18.9291 21.2542 18.6167 21.5666L16.3539 23.8294C14.7918 25.3915 12.2592 25.3915 10.6971 23.8294C9.13498 22.2673 9.13498 19.7346 10.6971 18.1725L12.9598 15.9098C13.2722 15.5973 13.7788 15.5973 14.0912 15.9098C14.4036 16.2222 14.4036 16.7287 14.0912 17.0411L11.8285 19.3039Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9392 12.1922C19.8764 11.2549 21.396 11.2549 22.3333 12.1922C23.2705 13.1294 23.2705 14.649 22.3333 15.5863L20.0705 17.849C19.7581 18.1614 19.7581 18.668 20.0705 18.9804C20.383 19.2928 20.8895 19.2928 21.2019 18.9804L23.4647 16.7177C25.0268 15.1556 25.0268 12.6229 23.4647 11.0608C21.9026 9.49871 19.3699 9.49871 17.8078 11.0608L15.5451 13.3235C15.2326 13.636 15.2326 14.1425 15.5451 14.4549C15.8575 14.7673 16.364 14.7673 16.6764 14.4549L18.9392 12.1922Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5768 19.9504C14.2644 19.6379 14.2644 19.1314 14.5768 18.819L18.4558 14.94C18.7682 14.6276 19.2747 14.6276 19.5872 14.94C19.8996 15.2524 19.8996 15.759 19.5872 16.0714L15.7082 19.9504C15.3957 20.2628 14.8892 20.2628 14.5768 19.9504Z" fill="white"/>
                </svg>
            </i>
        `
    }

    // 프로젝트 참여 - 1.외부인 아이콘
    externalEmplTemplate(){
        return `
            <i>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="17" cy="17.5" r="17" fill="#520060"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9828 17.6536C18.4247 17.6536 19.5936 16.4847 19.5936 15.0428C19.5936 13.6009 18.4247 12.432 16.9828 12.432C15.5409 12.432 14.372 13.6009 14.372 15.0428C14.372 16.4847 15.5409 17.6536 16.9828 17.6536ZM16.9828 19.2536C19.3083 19.2536 21.1936 17.3684 21.1936 15.0428C21.1936 12.7173 19.3083 10.832 16.9828 10.832C14.6572 10.832 12.772 12.7173 12.772 15.0428C12.772 17.3684 14.6572 19.2536 16.9828 19.2536Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9829 19.6273C13.825 19.6273 11.4667 21.8234 11.4667 24.3008C11.4667 24.7426 11.1085 25.1008 10.6667 25.1008C10.2249 25.1008 9.8667 24.7426 9.8667 24.3008C9.8667 20.7324 13.1641 18.0273 16.9829 18.0273C20.8017 18.0273 24.0991 20.7324 24.0991 24.3008C24.0991 24.7426 23.7409 25.1008 23.2991 25.1008C22.8573 25.1008 22.4991 24.7426 22.4991 24.3008C22.4991 21.8234 20.1408 19.6273 16.9829 19.6273Z" fill="white"/>
                </svg>
            </i>
        `
    }

    // 프로젝트 참여 - 2.회사직원 아이콘
    internalEmplTemplate(){
        return `
            <i>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_5370_1745)">
                    <circle cx="17" cy="17.5" r="17" fill="#9F00BA"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 13.0312H21.9999C23.5739 13.0312 24.8499 14.3072 24.8499 15.8812V24.8437C24.8499 26.4177 23.5739 27.6937 21.9999 27.6937H11.9999C10.4259 27.6937 9.1499 26.4177 9.1499 24.8437V15.8812C9.1499 14.3072 10.4259 13.0312 11.9999 13.0312ZM11.9999 14.6313C11.3095 14.6313 10.7499 15.1909 10.7499 15.8812V24.8437C10.7499 25.534 11.3095 26.0937 11.9999 26.0937H21.9999C22.6903 26.0937 23.2499 25.534 23.2499 24.8437V15.8812C23.2499 15.1909 22.6903 14.6313 21.9999 14.6313H11.9999Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4497 12.4992C12.4497 11.367 13.3675 10.4492 14.4997 10.4492H19.4997C20.6319 10.4492 21.5497 11.367 21.5497 12.4992V13.407C21.5497 13.8489 21.1915 14.207 20.7497 14.207C20.3079 14.207 19.9497 13.8489 19.9497 13.407V12.4992C19.9497 12.2507 19.7482 12.0492 19.4997 12.0492H14.4997C14.2512 12.0492 14.0497 12.2507 14.0497 12.4992V13.407C14.0497 13.8489 13.6915 14.207 13.2497 14.207C12.8079 14.207 12.4497 13.8489 12.4497 13.407V12.4992Z" fill="white"/>
                    <path d="M12.752 17.7344C12.752 17.4582 12.9758 17.2344 13.252 17.2344H15.752C16.0281 17.2344 16.252 17.4582 16.252 17.7344V19.2344C16.252 19.5105 16.0281 19.7344 15.752 19.7344H13.252C12.9758 19.7344 12.752 19.5105 12.752 19.2344V17.7344Z" fill="white"/>
                    <path d="M12.752 21.4844C12.752 21.2082 12.9758 20.9844 13.252 20.9844H15.752C16.0281 20.9844 16.252 21.2082 16.252 21.4844V22.9844C16.252 23.2605 16.0281 23.4844 15.752 23.4844H13.252C12.9758 23.4844 12.752 23.2605 12.752 22.9844V21.4844Z" fill="white"/>
                    <path d="M17.752 17.7344C17.752 17.4582 17.9758 17.2344 18.252 17.2344H20.752C21.0281 17.2344 21.252 17.4582 21.252 17.7344V19.2344C21.252 19.5105 21.0281 19.7344 20.752 19.7344H18.252C17.9758 19.7344 17.752 19.5105 17.752 19.2344V17.7344Z" fill="white"/>
                    <path d="M17.752 21.4844C17.752 21.2082 17.9758 20.9844 18.252 20.9844H20.752C21.0281 20.9844 21.252 21.2082 21.252 21.4844V22.9844C21.252 23.2605 21.0281 23.4844 20.752 23.4844H18.252C17.9758 23.4844 17.752 23.2605 17.752 22.9844V21.4844Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9494 11.8164C16.5076 11.8164 16.1494 11.4582 16.1494 11.0164L16.1494 8.53437C16.1494 8.09255 16.5076 7.73437 16.9494 7.73437C17.3912 7.73437 17.7494 8.09255 17.7494 8.53437L17.7494 11.0164C17.7494 11.4582 17.3912 11.8164 16.9494 11.8164Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_5370_1745">
                    <rect y="0.5" width="34" height="34" rx="17" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
            </i>
        `
    }

    setEvent() {
        const {id = '',  clickFunc = Mutil.noop } = this.$props;
        super.setEvent();
        const targetSelector = Mutil.empty(id) ? `.js-icon-button` : `#${id}`;
        this.addEvent("click.prevent", targetSelector, (e) => {
            if(typeof clickFunc === "function") {
                clickFunc();
            }
        });
    }

};

